module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schoolMsg"
  }, [_c('div', {
    staticClass: "menu clear"
  }, [_c('ul', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('li', {
    class: {
      activeLi: _vm.index == 1
    },
    on: {
      "click": function($event) {
        _vm.toggle(1)
      }
    }
  }, [_vm._v("我发送的")]), _vm._v(" "), _c('li', {
    class: {
      activeLi: _vm.index != 1
    },
    on: {
      "click": function($event) {
        _vm.toggle(2)
      }
    }
  }, [_vm._v("\n          我接收的\n          "), _c('i', {
    class: {
      msgPro: _vm.userInformation.isUnread
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "border_line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sendBox"
  }, [(_vm.index == 1) ? _c('sendMsg', {
    attrs: {
      "loadData": _vm.loadData
    }
  }) : _c('acceptMsg', {
    attrs: {
      "loadData": _vm.loadData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5272e90","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/schoolMsg/schoolMsg.vue
// module id = 1243
// module chunks = 1